<template>
  <div class="container-fluid p-0 vh-100 overflow-hidden">
    <div class="row g-0 h-100">

      <div class="col-12 col-lg-6 bg-white d-flex flex-column justify-content-center position-relative overflow-y-auto">



        <div class="w-100 mx-auto px-4" style="max-width: 500px;">
          <div class="mb-4">
            <h2 class="fw-bold text-dark">{{ appName }}</h2>
            <p class="text-muted">{{ $t('auth.description') }}</p>
          </div>

<!--          <div class="row g-3 mb-4">-->
<!--&lt;!&ndash;            <div class="col-6">&ndash;&gt;-->
<!--&lt;!&ndash;              <button class="btn btn-light w-100 d-flex align-items-center justify-content-center gap-2 border text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
<!--&lt;!&ndash;                  <path d="M17.64 9.20455C17.64 8.56636 17.5827 7.95273 17.4764 7.36364H9V10.845H13.8436C13.6336 11.97 13.0009 12.9232 12.0477 13.5614V15.8195H14.9564C16.6582 14.2527 17.64 11.9455 17.64 9.20455Z" fill="#4285F4"/>&ndash;&gt;-->
<!--&lt;!&ndash;                  <path d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5614C11.2418 14.1014 10.2109 14.4205 9 14.4205C6.65591 14.4205 4.67182 12.8373 3.96409 10.71H0.957275V13.0418C2.43818 15.9832 5.48182 18 9 18Z" fill="#34A853"/>&ndash;&gt;-->
<!--&lt;!&ndash;                  <path d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957275C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957275 13.0418L3.96409 10.71Z" fill="#FBBC05"/>&ndash;&gt;-->
<!--&lt;!&ndash;                  <path d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z" fill="#EA4335"/>&ndash;&gt;-->
<!--&lt;!&ndash;                </svg>&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="small fw-semibold">Sign in with Google</span>&ndash;&gt;-->
<!--&lt;!&ndash;              </button>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="col-6">-->
<!--              <button class="btn btn-light w-100 d-flex align-items-center justify-content-center gap-2 border text-muted">-->
<!--                <i class="bi bi-twitter-x"></i>-->
<!--                <span class="small fw-semibold">Sign in with X</span>-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="d-flex align-items-center mb-4">-->
<!--            <hr class="flex-grow-1 text-muted">-->
<!--            <span class="px-3 text-muted small">Or</span>-->
<!--            <hr class="flex-grow-1 text-muted">-->
<!--          </div>-->

          <ValidationObserver
              tag="form"
              @submit.prevent="authenticate"
              v-slot="{ invalid }"
              ref="observer"
              class="login100-form validate-form"
          >

            <ValidationProvider
                tag="div"
                :name="$t('auth.username')"
                rules="required"
                class="form-group mb-3"
                v-slot="{ errors }"
            >
              <label>{{ $t('auth.username') }} <span class="text-danger">*</span></label>
              <div class="wrap-input100 input-group">
                <a href="javascript:void(0)" class="input-group-text bg-white text-muted">
                  <i class="zmdi zmdi-email text-muted"></i>
                </a>
                <input
                    class="input100 border-start-0 form-control ms-0"
                    type="text"
                    v-model="username"
                    :placeholder="$t('auth.username')"
                    autofocus
                />
              </div>
              <small class="form-text text-danger">{{ errors[0] }}</small>
            </ValidationProvider>

            <ValidationProvider
                tag="div"
                :name="$t('auth.password')"
                rules="required"
                class="form-group"
                v-slot="{ errors }"
            >
              <label>{{ $t('auth.password') }} <span class="text-danger">*</span></label>
              <div class="wrap-input100 input-group" id="Password-toggle">
                <a href="javascript:void(0)" class="input-group-text bg-white text-muted">
                  <i class="zmdi zmdi-eye text-muted"></i>
                </a>

                <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    class="form-control form-control-lg bg-light border-light-subtle border-end-0"
                    placeholder="**********"
                    required
                >
                <span class="input-group-text bg-light border-light-subtle border-start-0 cursor-pointer" @click="showPassword = !showPassword">
                   <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'" class="text-muted"></i>
                </span>
              </div>
              <small class="form-text text-danger">{{ errors[0] }}</small>
            </ValidationProvider>


            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="rememberMe">
                <label class="form-check-label small text-muted" for="rememberMe">
                  {{ $t('auth.remember') }}
                </label>
              </div>
              <a href="#" class="text-primary text-decoration-none small">{{ $t('auth.forgot') }}</a>
            </div>

            <button class="btn btn-primary w-100 btn-lg mb-3" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              {{ loading ? $t('auth.logging') : $t('auth.login') }}
            </button>

            <div v-if="error" class="alert alert-danger py-2 small text-center">{{ error || $t('auth.error') }}</div>

<!--            <div class="text-center mt-4">-->
<!--              <span class="text-muted small">Don't have an account? </span>-->
<!--              <a href="#" class="text-primary text-decoration-none small fw-semibold">Sign Up</a>-->
<!--            </div>-->

          </ValidationObserver>
        </div>
      </div>

      <div class="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center text-white position-relative branding-section">
        <div class="branding-overlay"></div>

        <div class="text-center position-relative z-1 p-5">
          <div class="mb-4">
            <div class="d-inline-flex align-items-center justify-content-center  rounded-3 p-3 mb-3">
              <img src="/img/cn-tippee-gabon-145752.jpg" alt="Logo CNTIPPEE" style="height: 60px;">
            </div>
            <h1 class="display-5 fw-bold">{{ $t('branding.title') }}</h1>
          </div>

          <p class="lead opacity-75">
            {{ $t('branding.description') }}
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "SignInBS5",
    data() {
      return {
        username: '',
        password: '',
        error: '',
        loading: false,
        showPassword: false, // Ajouté pour gérer l'icône oeil
        appName: process.env.VUE_APP_NAME
      };
    },
    methods: {
      // Si vous utilisez Vuex, gardez ceci, sinon enlevez mapActions
      ...mapActions('auth', ['loginWithCredentials']),

      async authenticate() {
        this.loading = true;
        this.error = '';

        try {
          await this.loginWithCredentials({
            username: this.username,
            password: this.password,
          });

          this.$router.push(this.$route.query.redirect || { name: 'dashboard' });
        } catch (err) {
          this.error = err.message || "Erreur lors de la connexion.";
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
/* Import des icônes Bootstrap si pas déjà présent dans votre projet */
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css");

/* Personnalisation de la couleur primaire pour matcher "TailAdmin Blue" */
.btn-primary {
  background-color: #3C50E0; /* Le bleu vibrant de l'image */
  border-color: #3C50E0;
}
.btn-primary:hover {
  background-color: #3041B8;
  border-color: #3041B8;
}

.text-primary {
  color: #3C50E0 !important;
}

/* Styles pour les inputs */
.form-control:focus, .form-check-input:focus {
  border-color: #3C50E0;
  box-shadow: 0 0 0 0.25rem rgba(60, 80, 224, 0.25);
}

.cursor-pointer {
  cursor: pointer;
}

/* Section Droite (Branding) */
.branding-section {
  background-color: #1C2434; /* Bleu très foncé */
  /* Optionnel: image de fond quadrillée si vous en avez une */
  //background-image: linear-gradient(#24303F 1px, transparent 1px), linear-gradient(90deg, #24303F 1px, transparent 1px);
  background-image: url('/img/gaspar_yanga.jpg');
  background-size: cover;
  /* L'image est centrée */
  background-position: center center;
  /* L'image ne se répète pas */
  background-repeat: no-repeat;
}

/* Effet vignette sombre sur les bords de la section droite */
.branding-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* J'ai remplacé le dégradé radial par une couleur unie semi-transparente */
  /* C'est souvent plus propre sur une photo. Ajustez le 0.7 (opacité) selon vos besoins (entre 0 et 1) */
  background-color: rgba(28, 36, 52, 0.7);
  pointer-events: none;
}
</style>